attemptLoadResources = (localeName) ->
  localeName = localeName.toLowerCase()
  try
    locale = require("../data/locales/#{localeName}.yaml")
  catch
  finally
    locale

getResources = (localeName = "en") ->
  while localeName isnt ''
    resource = attemptLoadResources(localeName)
    return resource if resource
    localeArr = localeName.split('-')
    localeArr.pop()
    localeName = localeArr.join('-')
  attemptLoadResources(localeName)

initialize = (locale = navigator?.language or "en") ->
  polyglot    = new Polyglot({ locale })
  resources   = getResources(locale)
  enResources = getResources("en")

  polyglot.extend(enResources)
  polyglot.extend(resources)

  moment?.locale(locale)
  window.i18n = (args...) -> polyglot.t(args...)

module.exports = { initialize }
